export function convertItem(item) {
    return {
        id: item.id,
        name: getName(item),
        type: getType(item),
        image: getImage(item),
        imageBig: getImageBig(item),
        clientSapRef: getClientSapRef(item),
        clientEanRef: getClientEanRef(item),
        clientRef1: getClientRef1(item),
        prices: getPrices(item),
        status: getStatus(item)
    };
}

function getClientRef1(externalItem) {
    if (!checkNested(externalItem, "infosArticle", "client_ref1", "componentProperty", "value")) {
        return "";
    }

    return externalItem.infosArticle.client_ref1.componentProperty.value;
}

function getClientSapRef(externalItem) {
    if (!checkNested(externalItem, "infosArticle", "client_sap_ref", "componentProperty", "value")) {
        return "";
    }

    return externalItem.infosArticle.client_sap_ref.componentProperty.value;
}

function getClientEanRef(externalItem) {
    if (!checkNested(externalItem, "infosArticle", "client_ean_ref", "componentProperty", "value")) {
        return "";
    }

    return externalItem.infosArticle.client_ean_ref.componentProperty.value;
}

function getName(externalItem) {
    if (!checkNested(externalItem, "terms", "name", "en", "value")) {
        return "";
    }

    return externalItem.terms.name.en.value;
}

function getType(externalItem) {
    if (!checkNested(externalItem, "type")) {
        return "";
    }

    return externalItem.type;
}

function getPrices(externalItem) {
    if (!checkNested(externalItem, "prices")) {
        return "";
    }

    return externalItem.prices;
}

function getStatus(externalItem) {
    if (!checkNested(externalItem, "status", "name")) {
        return "";
    }

    return externalItem.status.name.toLowerCase();
}

function getImage(externalItem) {
    if (!checkNested(externalItem, "figures", "small")) {
        return "";
    }

    return externalItem.figures.small;
}

function getImageBig(externalItem) {
    if (!checkNested(externalItem, "figures", "big")) {
        return "";
    }

    return externalItem.figures.big;
}

// Function to check if object property path exists, see https://stackoverflow.com/a/2631198
function checkNested(obj, level, ...rest) {
    if (!obj || !level || !rest) {
        return false;
    }
    if (obj === undefined) return false;
    if (rest.length === 0 && obj.hasOwnProperty(level)) return true;
    return checkNested(obj[level], ...rest);
}



// WEBPACK FOOTER //
// ./src/components/forecasts/model/item.js